import { combineReducers } from 'redux';
import { featureFlagsReducer } from './reducers/feature-flags-reducer';

export default combineReducers({
  featureFlagsReducer
});
